import { PetAPIResponseType } from "../types/pet";
import DogCard from "./DogCard";

const staticUrl: string = process.env.STATIC_URL;

export default function PetGrid({ pets, total }: { pets: PetAPIResponseType[]; total: number }) {
  return (
    <>
      <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-4">
        {pets.map((pet) => {
          return (
            <DogCard
              key={pet.id}
              image={`${staticUrl}${pet.images[0].url}`}
              shelter={pet.user.profile.title}
              country={pet.user.profile.country}
              {...pet}
            />
          );
        })}
      </div>
    </>
  );
}
